import React from 'react';
import PropTypes from 'prop-types';
import styled from '@emotion/styled';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import {InputBase, withStyles} from '@material-ui/core';
import FormControl from '@material-ui/core/FormControl';
import Input from '@material-ui/core/Input';
import CustomInputField, {CustomInputLabel} from './CustomInputField';

const SelectionWrapper = styled.div``;

const CustomSelect = withStyles({
    root: props => ({
        width: props.width ? `${props.width}px` : '140px',
        background: '#FFFFFF',
        border: '1.2px solid #E2E8F0',
        boxSizing: 'border-box',
        borderRadius: '4px',
        padding: '8px',
        margin: 0,
    })
})(Select);

function CustomSelection(props) {
    const {onChange, value, label, width} = props;
    return (
        <SelectionWrapper>
            <CustomInputLabel id="customized-select-label">{label}</CustomInputLabel>
            <CustomSelect
                id="customized-select"
                value={value}
                native={false}
                input={<Input disableUnderline={true}/>}
                onChange={onChange}
                width={width}
            >
                {props.children}
            </CustomSelect>
        </SelectionWrapper>
    );
}

CustomSelection.propTypes = {
    onChange: PropTypes.func.isRequired,
    value: PropTypes.any.isRequired,
    label: PropTypes.string,
    width: PropTypes.number
};
CustomSelection.defaultProps = {};

export default CustomSelection;
